<template>
  <div class="main_right">
    <breadcrumb :breadcrumb="config.breadcrumb" />
    <div class="account">

      <div class="content access_ctrl">
        <!-- region 顶部操作栏 -->
        <div class="top-bar">
          <div class="left">
            <button-add @click="handleAdd()" v-if="permissionCodes.indexOf('009001001') !== -1" />
            <button-delete @click="remove(selected)" v-if="permissionCodes.indexOf('009001002') !== -1"/>
          </div>
          <!--<div>-->
            <!--<p class="statues">-->
              <!--设备状态-->
              <!--<el-select v-model="requestBody.deviceStatus" placeholder="全部"-->
                         <!--size="small" @change="handleSelect">-->
                <!--<el-option v-for="item in deviceOptions" :key="item.id"-->
                           <!--:label="item.label" :value="item.id">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</p>-->
            <!--<p class="statues">-->
              <!--设备类型-->
              <!--<el-select v-model="requestBody.deviceType" placeholder="全部"-->
                         <!--size="small" @change="deviceTypeSelect">-->
                <!--<el-option v-for="item in deviceTypeOptions" :key="item.id"-->
                           <!--:label="item.label" :value="item.id">-->
                <!--</el-option>-->
              <!--</el-select>-->
            <!--</p>-->
          <!--</div>-->
          <input-search class="search" @search="search" placeholder="设备名称/编号" />
        </div>
        <!--<div class="top-bar">-->
          <!---->
          <!--<div style="display: flex; justify-content: space-between;">-->
            <!--<button-upload-->
              <!--:cathUrl="uploadUrl"-->
              <!--:onSuccess="onUploadSuccess"-->
              <!--value="导入"/>-->
            <!--<button-export-->
              <!--:href="exportUrl"-->
              <!--download="download.xls"-->
              <!--value="导出"/>-->
          <!--</div>-->
        <!--</div>-->
        <!-- endregion 顶部操作栏 -->
        <!-- region 表格 -->
        <el-table class="width-full" :data="posDevices" :height="618"
                  header-row-class-name="app-center-table-header"
                  @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column label="设备名称">
            <template slot-scope="scope">
              <span :title="scope.row.deviceName">{{scope.row.deviceName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备编号">
            <template slot-scope="scope">
              <span :title="scope.row.deviceCode">{{scope.row.deviceCode}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备类型" >
            <template slot-scope="scope">
              <span :title="scope.row.deviceTypeName">{{scope.row.deviceTypeName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备型号" >
            <template slot-scope="scope">
              <span :title="scope.row.deviceModelName">{{scope.row.deviceModelName}}</span>
            </template>
          </el-table-column>
          <el-table-column label="设备状态" width="160">
            <template slot-scope="scope">
              <div style="background-color: #F56C6C;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-if="scope.row.deviceStatus === '0'"></div>
              <div style="background-color: #67C23A;width: 15px;height: 15px;border-radius: 50%;margin: 0 auto;" v-else-if="scope.row.deviceStatus === '1'"></div>
            </template>
          </el-table-column>
          <el-table-column label="设备位置">
            <template slot-scope="scope">
              <span :title="scope.row.location">{{scope.row.location}}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="160">
            <template slot-scope="scope">
              <a @click="toModifyPage(scope.row.deviceCode)">修改</a>
              <a @click="remove(scope.row.deviceCode)">删除</a>
            </template>
          </el-table-column>
        </el-table>
        <!-- endregion 表格 -->
        <div class="ladder-page">
          <el-pagination background layout="total, prev, pager, next, jumper"
                         @current-change="onPageChanged" :total="total">
          </el-pagination>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from "../../api/LadderControl";
import { nAlert, nSuccess, nTipFunc, nWarn } from "../../../utils/notice";
import InputSearch from "../../../components/common/inputs/input-search";
import ButtonAdd from "../../../components/common/buttons/button-add";
import ButtonDelete from "../../../components/common/buttons/button-delete";
import ButtonExport from "../../../components/common/buttons/button-export";
import ButtonUpload from "../../../components/common/buttons/button-upload";
import BreadCrumb from "../../../components/common/di-ding/common/bread-crumb";
import { errorHandler } from "../../../utils/errorHandler";
import Breadcrumb from "../../../components/Breadcrumb/Breadcrumb";
import STree from "../../../components/common/s-tree";
import { bus } from "../../../utils/bus";

export default {
  name: "ladder-device",
  components: {
    STree,
    Breadcrumb,
    BreadCrumb,
    ButtonUpload,
    ButtonExport,
    ButtonDelete,
    ButtonAdd,
    InputSearch
  },
  data() {
    return {
      deviceOptions: [
        {
          id: "",
          label: "全部"
        },
        {
          id: "0",
          label: "离线"
        },
        {
          id: "1",
          label: "在线"
        }
      ],
      deviceTypeOptions: [
        {
          id: "",
          label: "全部"
        },
        {
          id: "8",
          label: "梯控网关"
        }
      ],
      treeOptions: {
        1: ["add"],
        2: ["add", "patch", "delete"],
        3: ["add", "patch", "delete"],
        4: ["patch", "delete"]
      },
      config: {
        breadcrumb: [
          {
            value: "智慧梯控",
            name: "ladder-device"
          },
          {
            value: "设备管理"
          }
        ]
      },
      // endregion 更新树的方法
      exportUrl: api.accessDeviceInfoDownloadUrl(),
      uploadUrl: api.accessDeviceInfoUploadUrl(),
      filterText: "",
      posDevices: [],
      total: 0,
      requestBody: {
        pageNum: "1",
        pageSize: "10",
        searchKey: "",
        deviceStatus: "",
        deviceType: ""
      },
      id: "1",
      selected: "",
      permissionCodes: ""
    };
  },
  created() {
    this.permissionCodes = bus.global.permissionCodes;
    this.render();
  },
  activated() {
    this.render();
  },
  watch: {
    $route() {
      this.render();
    }
  },
  methods: {
    /**
     * 多选框选择事件
     */
    handleSelectionChange(selectedIds) {
      console.log(selectedIds);
      let deviceCodeArr = [];
      selectedIds.map(v => {
        deviceCodeArr.push(v.deviceCode);
      });
      this.selected = deviceCodeArr.join(",");
    },

    /**
     * 移除
     */
    remove(codes) {
      if (codes.length === 0) {
        nWarn("请先选择需要删除的设备");
        return;
      }
      this.$confirm("确认删除？").then(
        () => {
          api
            .deleteAccessDevice({ codes: codes })
            .then(nTipFunc("删除成功"))
            .then(this.render);
        },
        () => {
          console.debug("用户取消了删除");
        }
      );
    },

    render() {
      this.renderPosDevices();
    },

    renderPosDevices() {
      api.getAccessDevice(this.requestBody).then(data => {
        this.total = data.total;
        data.list.map(v => {
          if (v.deviceType === "8") {
            v.deviceTypeName = "梯控网关";
          } else {
            v.deviceTypeName = "--";
          }
        });
        this.posDevices = data.list;
      });
    },

    onPageChanged(page) {
      this.requestBody.pageNum = page + "";
      this.renderPosDevices();
    },

    search(val) {
      this.requestBody.pageNum = "1";
      this.requestBody.searchKey = val;
      this.renderPosDevices();
    },

    handleSelect(val) {
      this.requestBody.deviceStatus = val;
      this.renderPosDevices();
    },

    deviceTypeSelect(val) {
      this.requestBody.deviceType = val;
      this.renderPosDevices();
    },

    handleAdd() {
      this.$router.push({
        path: "/ladder_device_add"
      });
    },

    toModifyPage(code) {
      this.$router.push({
        path: "/ladder_device_modify/" + code
      });
    },

    onUploadSuccess(data) {
      const e = errorHandler("导入失败")(data);
      if (!(e instanceof Error)) {
        nSuccess("导入成功");
        this.render();
      }
    }
  }
};
</script>

<style scoped>
.account {
  display: flex;
  justify-content: space-between;
}

.school {
  width: 22%;
  float: left;
  padding: 20px 10px 0 0;
  border-right: 1px solid #e6ebf2;
}

.yq_name li {
  width: 100px;
}

.content {
  width: 100%;
  height: 100%;
  padding-top: 20px;
  position: relative;
}

.statues {
  display: inline-block;
  line-height: 32px;
  margin-right: 10px;
}

.select-box select {
  width: 60%;
  height: 24px;
  margin-left: 5px;
  border: 1px solid #d7d7d7;
}

.info ul {
  height: 42px;
  color: #48576a;
  font-weight: 400;
  background-color: #eff1f5;
  line-height: 40px;
  margin-top: 5px;
}

.ladder-page {
  margin: 20px auto 0;
}
.width-full a {
  color: #00a0e6;
}
.width-full a:hover {
  color: #06b3ff;
}
</style>

<style lang="less">
.top-bar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  flex: 1;
  margin: 0 10px 15px 15px;
  .left {
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .search {
    width: 240px;
  }
  .export {
    width: 80px;
    height: 30px;
    line-height: 30px;
    color: #ffffff;
    border-radius: 5px;
    float: left;
    font-size: 14px;
    margin-right: 2%;
    text-align: center;
    font-weight: 400;
    color: #48576a;
    border: 1px solid #d7d7d7;
    background-color: #f7f7f7;
    &:hover {
      color: #00a0e6 !important;
      border: 1px solid #00a0e6 !important;
    }
  }
}
.el-tree-node.is-current > .el-tree-node__content {
  background-color: #f0f7ff;
}

.app-center-table-header th {
  background-color: #eff1f5 !important;
  color: #48576a;
  .cell {
    text-align: center;
  }
}
.el-table .cell {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/view/LadderControl/LadderDevice/LadderDevice.vue